import script from "./SignupCustomFields.vue?vue&type=script&setup=true&lang=js"
export * from "./SignupCustomFields.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__